import { useLinkRelValue, useStoryblokLink } from "hooks";
import NextLink from "next/link";
import { ChakraLink } from "@airhelp/react-ui-components";
import type { LinkProps } from "./Link.d";

const Link = ({ children, href, target, linktype, styles, uuid }: LinkProps) => {
  const relValue = useLinkRelValue(href, linktype);
  const link = {
    id: uuid,
    url: href,
    linktype,
    fieldtype: "multilink",
    cached_url: "",
  };
  const url = useStoryblokLink(link);

  if (linktype === "email")
    return (
      <ChakraLink as={NextLink} href={`mailto:${href}`} passHref sx={styles}>
        {children}
      </ChakraLink>
    );

  return (
    <ChakraLink as={NextLink} href={url} passHref rel={relValue} target={target} sx={styles}>
      {children}
    </ChakraLink>
  );
};

export default Link;
